// extracted by mini-css-extract-plugin
module.exports = {"loadingBox":"loadingBox__10_EJ","successMessage":"successMessage__21-Uk"};